const InsightEmpty = () => import('@master/views/insight/InsightEmpty.vue');
import analyticsService from '@assets/services/analytics.service';

export default [
    {
        name: 'Insight',
        path: 'insight/:path*',
        component: InsightEmpty,
        beforeEnter: function (to, from, next) {
            analyticsService.sendProductActiveTime('pti');
            next();
        },
        meta: {
            protocol: 'http'
        }
    }
];
